let endpointUrl = '/sparql';
let virtuosoUrl = '/sparql';
let options = {endpointUrl, credentials: 'same-origin', mode: 'no-cors'};

/** Параметр, содержащий подключение к SPARQL Virtuoso */
const virtuoso_sparql_endpoint_url = "virtuoso.sparql.endpoint.url";
/** Параметр, содержащий IRI публичного каталога. Этот IRI используется 
 * в фильтре получения списка элементов каталога доступных неавторизованному пользователю */
const virtuoso_catalog_iri_public ="virtuoso.catalog.iri.public";
/** Параметр, содержащий IRI каталога. Этот IRI используется в фильтре
 *  получения списка элементов каталога авторизованным пользователям */
const virtuoso_catalog_iri ="virtuoso.catalog.iri";
/** Параметр, содержащий URI графа с публичным каталогом */
const virtuoso_catalog_graph_public = "virtuoso.catalog.graph.public";
/** Параметр, содержащий URI графа с приватным каталогом */
const virtuoso_catalog_graph_signed = "virtuoso.catalog.graph.signed";
/** Параметр, содержащий идентификатор элемента в DOM c настройками */
const id_settings = "settings";

/** В HTML странице должен быть элемент с id_settings в котором атрибут virtuoso_sparql_endpoint_url содержит адрес 
 * SPARQL Virtuoso
 *  например  <div class="display: none;" id="settings"
 *   virtuoso.sparql.endpoint.url="http://sparql.semanticpro.org/sparql" 
 *   virtuoso.catalog.iri.public="http://purl.cisstat.org/catalog/sa"   #2025-0325 Mishael новая настройка для публичного каталога
 *   virtuoso.catalog.graph.public="http://csi.semanticpro.org/ADMS"
 *   virtuoso.catalog.iri="http://hbz.ru/adms/catalog"
 *   virtuoso.catalog.graph.signed="http://csi.semanticpro.org/ADMS"></div>
 */
const loadVirtuosoSettings = settings =>{
	const node = document.getElementById(id_settings);
	if (!node){
		alert("Параметры соединения c графовой базов отсутствуют!\nБудут использованы встроенные настройки!\nОбратитесь к администратору системы.")
		return;
	}
    if (node.getAttribute(virtuoso_sparql_endpoint_url)==null){
		console.warn("SPARQL url not setting ("+virtuoso_sparql_endpoint_url+" empty)!");
	} else {
        settings.endpointUrl = node.getAttribute(virtuoso_sparql_endpoint_url);
        settings.options.endpointUrl = node.getAttribute(virtuoso_sparql_endpoint_url);
    }

    if (node.getAttribute(virtuoso_catalog_iri)==null)
		console.warn("IRI catalog not setting ("+virtuoso_catalog_iri+" empty)!");
	 else 
        settings.catalog.signed = node.getAttribute(virtuoso_catalog_iri);
    if (node.getAttribute(virtuoso_catalog_iri_public)==null)
		console.warn("IRI public catalog not setting ("+virtuoso_catalog_iri_public+" empty)!");
	 else 
        settings.catalog.public = node.getAttribute(virtuoso_catalog_iri_public);

    if (node.getAttribute(virtuoso_catalog_graph_public)==null)
		console.warn("Public graph not setting ("+virtuoso_catalog_graph_public+" empty)!");
	 else 
        settings.catalog.graph.public = node.getAttribute(virtuoso_catalog_graph_public);

    if (node.getAttribute(virtuoso_catalog_graph_signed)==null)
		console.warn("Private graph not setting ("+virtuoso_catalog_graph_signed+" empty)!");
	 else 
        settings.catalog.graph.signed = node.getAttribute(virtuoso_catalog_graph_signed);

    settings.catalog.iri = settings.catalog.public;
    settings.catalog.graph.iri = settings.catalog.graph.public;
    if (settings.catalog.signed == undefined || settings.catalog.signed == null || settings.catalog.signed == "")
        settings.catalog.signed = settings.catalog.iri;
    if (settings.catalog.graph.signed == undefined || settings.catalog.graph.signed == null || settings.catalog.graph.signed == "")
        settings.catalog.graph.signed = settings.catalog.graph.iri;

    console.log("virtuoso settings", settings);
	return settings;
}

//if (process.env.NODE_ENV === 'development') {
    //Режим разработки подключается к csi.semanticpro.org
    //const publicEndpoinURL = 'http://sparql.semanticpro.org/sparql';
    //const signedInEndpoinURL = 'http://sparql.semanticpro.org/sparql';
    const publicEndpoinURL = 'http://csi2.semanticpro.org/sparql/';
    const signedInEndpoinURL = 'http://csi2.semanticpro.org/sparql/';

    endpointUrl = publicEndpoinURL;
    if (window.Liferay){
        if (window.Liferay.ThemeDisplay.isSignedIn())
            endpointUrl = signedInEndpoinURL;
    }
    options.credentials = 'include';
    options.mode='cors';
    options.endpointUrl = endpointUrl;    
//}

let settings = loadVirtuosoSettings({
    endpointUrl,
    virtuosoUrl,
    loadTimeout: 300000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    defaultLocale: 'ru',
    virtuoso_username: 'user@virtuoso.local',
    virtuoso_password: 'passw0rd',
    options,
    defaultLimit: 10,
    catalog : { 
        //Текущий  (используется при формировании SPARQL запросов)
        iri: "http://hbz.ru/adms/catalog",
        //Закрытый каталог (из настройки)
        signed: "http://hbz.ru/adms/catalog",
        //Публичный каталог (из настройки)
        public : "http://hbz.ru/adms/catalog",
        graph: {
            //Текущий IRI графа (используется при выполнении SPARQL запросов)
            iri: "http://csi.semanticpro.org/ADMS_PUBLIC",
            //IRI графа (из настройки) с публичным каталогом
            public: "http://csi.semanticpro.org/ADMS_PUBLIC",
            //IRI графа (из настройки) с закрытым каталогом
            signed: "http://csi.semanticpro.org/ADMS"    
        },
        //Выбранный язык в каталоге
        lang: undefined
    }
});

export default settings;
